<template>
    <div>
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
        >
            <div
                v-for="(item,index) in dataList" :key="item.id"
                class="stamp"
                v-bind:class="{ 
                    'stamp-1':(index % 4) + 1 == 1, 
                    'stamp-2':(index % 4) + 1 == 2,
                    'stamp-3':(index % 4) + 1 == 3, 
                    'stamp-4':(index % 4) + 1 == 4,
                    'have':item.status != 0
                }"
            >
                <div class="par">
                    <p class="p">{{ item.shop_name }}</p>
                    <span class="span">{{ item.title }}</span>
                    <van-button v-if="getStatus()" type="danger" size="mini" style="background-color: transparent;border: 1px solid white" @click="gift(item, 2, (index % 4) + 1)">转赠</van-button>
                </div>
                <div class="copy">
                    <span>{{ item.title }}</span>
                    <div v-if="item.status == 0">
                        <p>{{ item.begin_date }}</p>
                        <p>{{ item.end_date }}</p>
                    </div>
                    <div v-if="item.status != 0">
                        <p>{{ getStatusName(item.status) }}</p>
                        <p></p>
                    </div>
                </div>
                <i></i>
            </div>
        </van-list>
    </div>
</template>

<script>
import { List, Button } from 'vant';
import { VoucherApi } from '@/api/vip'

export default {
    props: ['params'],
    components:{
        [List.name]: List,
        [Button.name]: Button
    },
    data() {
        return {
            dataList: [],
            loading: false,
            finished: false,
            query: {
                page: 0,
                status__in: null
            },
        }
    },
    mounted(){
        console.log(this.params)
    },
    methods:{
        getStatus(){
            if(this.params.status__in==='0'){   // 未使用状态才可以转赠
                return true
            }else{
                return false
            }
        },
        gift(item, type, itemClass){
            this.$router.push({
                path: '/nt/user/coupondetail',
                query: {
                    item: item,
                    type: type,
                    itemClass: `stamp-${itemClass}`
                }
            })
        },
        onLoad() {
            this.query.page+=1
            this.query.status__in = this.params.status__in
            this.getCoupon()
         },
        getCoupon(){
            var that = this
            that.axios.get(VoucherApi, {params: that.query}).then((ret) => {
                that.loading = false
                ret.results.forEach(it => {
                    that.dataList.push({
                        id: it.id,
                        shop_name: it.shop_name,
                        title: it.project_extra.name,
                        begin_date: it.begin_date,
                        end_date: it.end_date,
                        project_id: it.project_id,
                        project_type: it.project_type,
                        status: it.status
                    })
                });
                if (ret.results == null || ret.results.length ===0 || ret.next == null) {
                    that.finished = true
                    return
                 }
            })
        },
         // 根据卡券状态生成对应名称
        getStatusName(status) {
            var name = undefined;
            switch (status) {
            case 2:
                name = '已作废';
                break;
            case 3:
                name = '已转赠';
                break;
            case 4:
                name = '已过期';
                break;
            case 1:
                name = '已使用';
                break;
            default:
                break;
            }
            return name;
        }
    }
}
</script>

<style lang="less" scoped>
    .stamp {
        width: 92%;
        height: 140px;
        padding: 0 0px;
        margin: 4%;
        position: relative;
        overflow: hidden;
        p {
            padding: 0;
            margin: 0;
        }
        &:before {
            content: '';
            position: absolute;
            top: 0;
            bottom: 0;
            left: 10px;
            right: 10px;
            z-index: -1;
        }
        i {
            position: absolute;
            left: 20%;
            top: 45px;
            height: 190px;
            width: 390px;
            background-color: rgba(255, 255, 255, 0.15);
            transform: rotate(-30deg);
            -ms-transform: rotate(-30deg);
            -moz-transform: rotate(-30deg);
            -webkit-transform: rotate(-30deg);
            -o-transform: rotate(-30deg);
        }
        .par {
            float: left;
            height: 100%;
            padding: 6% 15px;
            width: 51%;
            border-right: 2px dashed rgba(255, 255, 255, 0.3);
            text-align: left;
            .p {
                color: #fff;
                font-size: 16px;
                line-height: 21px;
                margin: 4px 0;
            }
            .span {
                font-size: 24px;
                color: #fff;
                margin-right: 5px;
                line-height: 30px;
            }
            button {
                position: absolute;
                bottom: 10%;
                left: 40%;
                z-index: 1;
            }
        }
        .copy {
            padding: 30px 0;
            vertical-align: text-bottom;
            font-size: 18px;
            color: rgb(255, 255, 255);
            text-align: center;
            line-height: initial;
            p:last-child {
                margin-top: 0px;
            }
            p {
                margin-top: 16px;
                font-size: 16px;
            }
        }
    }
    .stamp-1 {
        background: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, #F39B00 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;
        &:before {
            background-color: #F39B00;
        }
    }
    .stamp-2 {
        background: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, #D24161 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;
        &:before {
            background-color: #D24161;
        }
    }
    .stamp-3 {
        background: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, #7EAB1E 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;
        &:before {
            background-color: #7EAB1E;
        }
    }
    .stamp-4 {
        background: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, #50ADD3 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;
        &:before {
            background-color: #50ADD3;
        }
    }
    .have {
        background: radial-gradient(rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0) 5px, #C1C1C1 5px);
        background-size: 15px 15px;
        background-position: 9px 3px;
        &:before {
            background-color: #C1C1C1;
        }
    }
</style>